// extracted by mini-css-extract-plugin
export default {"container":"Message-module--container--5bb66","order":"Message-module--order--98faa"};